import AdminLogin from "../components/admin/AdminLogin";
import AdminDashboard from "../components/admin/AdminDashboard";
import { useAdmin } from "../hooks/useAdmin";

export default function AdminPage() {
  const admin = useAdmin();

  if (!admin.isAuthenticated) {
    return (
      <AdminLogin
        login={admin.login}
        loginError={admin.loginError}
        loginLoading={admin.loginLoading}
        loginAttempts={admin.loginAttempts}
      />
    );
  }

  return (
    <AdminDashboard
      users={admin.users}
      totalCount={admin.totalCount}
      dataLoading={admin.dataLoading}
      dataError={admin.dataError}
      stats={admin.stats}
      statsLoading={admin.statsLoading}
      chartData={admin.chartData}
      chartLoading={admin.chartLoading}
      search={admin.search}
      handleSearch={admin.handleSearch}
      page={admin.page}
      setPage={admin.setPage}
      PAGE_SIZE={admin.PAGE_SIZE}
      selectedIds={admin.selectedIds}
      toggleSelect={admin.toggleSelect}
      toggleSelectAll={admin.toggleSelectAll}
      handleUpdateStatus={admin.handleUpdateStatus}
      handleDeleteUser={admin.handleDeleteUser}
      handleBulkUpdateStatus={admin.handleBulkUpdateStatus}
      handleBulkDelete={admin.handleBulkDelete}
      handleExportCSV={admin.handleExportCSV}
      handleCopyEmails={admin.handleCopyEmails}
      fetchUsers={admin.fetchUsers}
      fetchStats={admin.fetchStats}
      fetchChartData={admin.fetchChartData}
      realtimeActive={admin.realtimeActive}
      newSignupFlash={admin.newSignupFlash}
      logout={admin.logout}
    />
  );
}
